import React, {useState, useMemo, useEffect} from "react";
import {Col, Row, Badge, Card, Button} from "react-bootstrap";
import {useDispatch} from "react-redux";
import {Link} from "react-router-dom";
import {DeleteModal} from "Common/DeleteModal";
import {useNavigate, useLocation} from "react-router-dom";
import {deleteProduct as onDeleteProduct} from "../../../slices/product/thunk";
import Pagination from "../../../Common/Pagination";
const url = process.env.REACT_APP_API_URL;

const ProductCard = ({filterGrid, setPagination, totalPages, pagination}: any) => {
    const dispatch = useDispatch<any>();
    const navigate = useNavigate();
    const location = useLocation();
    const [show, setShow] = useState(false);
    const [deleteId, setDeleteId] = useState();

    const handleDeleteShow = () => setShow(true);
    const handleDeleteClose = () => setShow(false);
    const handleDelete = (id: any) => {
        handleDeleteShow();
        setDeleteId(id);
    }

    //delete modal
    const deleteModalFunction = () => {
        dispatch(onDeleteProduct(deleteId));
        handleDeleteClose();
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        params.set("page", pagination.toString());
        navigate({search: params.toString()}, {replace: true});
    }, [pagination, navigate, location.search]);

    return (
        <React.Fragment>
            <Col xxl={9}>
                <Row className="align-items-center mb-4 g-3">
                    <Col xxl={2} lg={4} sm={6} className="me-auto">
                        <h5 className="mb-0">Products
                            <Badge className="bg-secondary-subtle text-secondary align-middle ms-1">
                                {filterGrid.totalElements}
                            </Badge>
                        </h5>
                    </Col>
                    <Col className="col-lg-auto">
                        <Link to={"/create-product"} className="btn btn-primary">
                            <i className="bi bi-plus-circle align-baseline me-1"></i> Add Product</Link>
                    </Col>
                </Row>

                <Row id="product-grid">
                    {
                        (filterGrid.content || [])?.map((item: any) => {
                            return (
                                <Col xxl={3} lg={4} md={6} key={item.id}>
                                    <Card className="ribbon-box ribbon-fill">
                                        <div className="ribbon ribbon-danger">Sale</div>
                                        {
                                            item.sale &&
                                            <div className="ribbon ribbon-danger">Sale</div>
                                        }
                                        <Card.Body className="p-4 m-4">
                                            <Button
                                                size="sm"
                                                type="button"
                                                className=" btn-icon btn-subtle-danger position-absolute top-0 end-0 m-3"
                                                onClick={() => handleDelete(item.id)}
                                            >
                                                <i className="ph-trash"></i>
                                            </Button>
                                            <img src={url + item.images[0]?.url} alt=""
                                                 className="img-fluid"/>
                                        </Card.Body>
                                        <Card.Body className="pt-0">
                                            <Badge text="warning" className="bg-warning-subtle float-end">
                                                <i className="bi bi-star-fill align-baseline me-1"></i>
                                                <span className="rate">{item.ratings}100</span>
                                            </Badge>
                                            <h5 className="fs-lg mb-3">${item.basePrice}
                                                {
                                                    item.delete && <small
                                                        className="fs-sm fw-normal text-decoration-line-through text-muted">${item.delete}</small>
                                                }
                                            </h5>
                                            <Link to={`/apps-ecommerce-product-details?id=${item.id}`}>
                                                <h6 className="fs-md text-truncate">{item.name}</h6>
                                            </Link>
                                            <Link to="#" className="text-decoration-underline text-muted mb-0">
                                                {item.categoryDto?.name}
                                            </Link>
                                            <div className="mt-3 hstack gap-2">
                                                <Link to={`/create-product?id=${item.id}`}
                                                      className="btn btn-primary w-100">
                                                    <i className="ph-pencil me-1 align-middle"></i>
                                                    Edit
                                                </Link>
                                                <Link to={`/product-details?id=${item.id}`}
                                                      className="btn btn-secondary w-100">
                                                    <i className="ph-eye me-1 align-middle"></i>
                                                    Overview</Link>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )
                        })
                    }

                    <div className={"d-flex justify-content-end"}>
                        <Pagination
                            currentPage={pagination}
                            totalPages={totalPages}
                            onPageChange={(page: number) => setPagination(page)}
                        />
                    </div>
                </Row>

            </Col>
            <DeleteModal show={show} handleClose={handleDeleteClose} deleteModalFunction={deleteModalFunction}/>
        </React.Fragment>
    )
};
export default ProductCard;